import React, { useEffect } from "react";

import Checkmark from "../../common/Checkmark";
import teacherGe from "../../../resources/teachers/葛老师——.jpg";
import teacherWang from "../../../resources/teachers/王老师——.jpg";
import meeting from "../../../resources/school/teacher-meeting.jpg";
import Row from "../../common/Row";
import { useTranslation } from "react-i18next";

const AboutUs = () => {
  const { t } = useTranslation("aboutUs");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="text-white text-center text-2xl bc bg-cover bg-center items-center space-y-4 p-16">
        <ul className="space-y-4">
          <div>
            <span className="bg-emerald-400 bg-opacity-50 p-1">
              {t("hero.line1")}
            </span>
          </div>
          <div>
            <span className="bg-emerald-400 bg-opacity-50 p-1">
              {t("hero.line2")}
            </span>
          </div>
          <div>
            <span className="bg-emerald-400 bg-opacity-50 p-1">
              {t("hero.line3")}
            </span>
          </div>
          <div>
            <span className="bg-emerald-400 bg-opacity-50 p-1">
              {t("hero.line4")}
            </span>
          </div>
          <div>
            <span className="bg-emerald-400 bg-opacity-50 p-1">
              {t("hero.line5")}
            </span>
          </div>
        </ul>
      </div>

      <div className="bg-gray-100 text-center py-4 space-y-20">
        <div className="text-2xl text-emerald-600 py-4 font-bold">
          {t("founders.title")}
        </div>

        {/* Founder 1 */}
        <div className="flex justify-center text-left">
          <img
            src={teacherGe}
            alt="img not found"
            className="md:w-1/6 w-1/3 rounded-full object-contain"
          />
          <div className="w-2/5 md:ml-32 ml-8">
            <div className="text-lg font-bold">{t("founders.ge.name")}</div>
            <div className="mt-4">{t("founders.ge.bio")}</div>
          </div>
        </div>

        {/* Founder 2 */}
        <div className="flex justify-center text-left">
          <img
            src={teacherWang}
            alt="img not found"
            className="md:w-1/6 w-1/3 rounded-full object-contain"
          />
          <div className="w-2/5 md:ml-32 ml-8">
            <div className="text-lg font-bold">{t("founders.wang.name")}</div>
            <div className="mt-4">{t("founders.wang.bio")}</div>
          </div>
        </div>
      </div>

      {/* Teacher team */}
      <div className="text-center py-4 space-y-8">
        <div className="text-2xl text-emerald-600 py-4 font-bold">
          {t("team.title")}
        </div>

        <div>{t("team.intro")}</div>

        <Row spaceClass="space-y-8">
          <ul className="md:w-1/3 space-y-4 text-left">
            {/* Item 1 */}
            <li className="flex">
              <Checkmark />
              <div className="ml-4">
                <div className="font-bold text-md">
                  {t("team.items.item1.title")}
                  <br />
                </div>
                <div className="text-sm font-normal">
                  {t("team.items.item1.desc1")}
                  <br />
                  {t("team.items.item1.desc2")}
                </div>
              </div>
            </li>

            {/* Item 2 */}
            <li className="flex">
              <Checkmark />
              <div className="ml-4">
                <div className="font-bold text-md">
                  {t("team.items.item2.title")}
                  <br />
                </div>
                <div className="text-sm font-normal">
                  {t("team.items.item2.desc1")}
                  <br />
                  {t("team.items.item2.desc2")}
                </div>
              </div>
            </li>

            {/* Item 3 */}
            <li className="flex">
              <Checkmark />
              <div className="ml-4">
                <div className="font-bold text-md">
                  {t("team.items.item3.title")}
                  <br />
                </div>
                <div className="text-sm font-normal">
                  {t("team.items.item3.desc1")}
                  <br />
                  {t("team.items.item3.desc2")}
                </div>
              </div>
            </li>

            {/* Item 4 */}
            <li className="flex">
              <Checkmark />
              <div className="ml-4">
                <div className="font-bold text-md">
                  {t("team.items.item4.title")}
                  <br />
                </div>
                <div className="text-sm font-normal">
                  {t("team.items.item4.desc1")}
                  <br />
                  {t("team.items.item4.desc2")}
                </div>
              </div>
            </li>
          </ul>

          <img
            src={meeting}
            alt="img not found"
            className="md:w-1/3 rounded-xl"
          />
        </Row>
      </div>

      {/* Localizable School History Timeline */}
      <div className="bg-gray-100 py-8">
        <div className="text-center text-2xl text-emerald-600 font-bold mb-8">
          {t("history.title")}
        </div>
        <div className="max-w-3xl mx-auto">
          <ul className="relative border-l-2 border-emerald-200 ml-4">
            {/* 2015 */}
            <li className="mb-8 ml-4">
              <div className="absolute -left-2 mt-1 h-3 w-3 rounded-full bg-emerald-500" />
              <div className="text-emerald-600 font-bold">
                {t("history.y2015.year")}
              </div>
              <div className="text-sm text-gray-700">
                {t("history.y2015.desc")}
              </div>
            </li>
            {/* 2016 */}
            <li className="mb-8 ml-4">
              <div className="absolute -left-2 mt-1 h-3 w-3 rounded-full bg-emerald-500" />
              <div className="text-emerald-600 font-bold">
                {t("history.y2016.year")}
              </div>
              <div className="text-sm text-gray-700">
                {t("history.y2016.desc")}
              </div>
            </li>
            {/* 2017 */}
            <li className="mb-8 ml-4">
              <div className="absolute -left-2 mt-1 h-3 w-3 rounded-full bg-emerald-500" />
              <div className="text-emerald-600 font-bold">
                {t("history.y2017.year")}
              </div>
              <div className="text-sm text-gray-700">
                {t("history.y2017.desc")}
              </div>
            </li>
            {/* 2022 */}
            <li className="mb-8 ml-4">
              <div className="absolute -left-2 mt-1 h-3 w-3 rounded-full bg-emerald-500" />
              <div className="text-emerald-600 font-bold">
                {t("history.y2022.year")}
              </div>
              <div className="text-sm text-gray-700">
                {t("history.y2022.desc")}
              </div>
            </li>
            {/* 2023 */}
            <li className="mb-8 ml-4">
              <div className="absolute -left-2 mt-1 h-3 w-3 rounded-full bg-emerald-500" />
              <div className="text-emerald-600 font-bold">
                {t("history.y2023.year")}
              </div>
              <div className="text-sm text-gray-700">
                {t("history.y2023.desc")}
              </div>
            </li>
            {/* 2024 */}
            <li className="mb-2 ml-4">
              <div className="absolute -left-2 mt-1 h-3 w-3 rounded-full bg-emerald-500" />
              <div className="text-emerald-600 font-bold">
                {t("history.y2024.year")}
              </div>
              <div className="text-sm text-gray-700">
                {t("history.y2024.desc")}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
